import { Box, Button, IconButton } from "@mui/material";
import SearchBar from "./SearchBar";
import FilterListIcon from '@mui/icons-material/FilterList';

 const TopToolbar = ({ searchText, setSearchText, onCreateClick, onToggleFilter, handleSearch, handleClearSearch }) => {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >

        <SearchBar searchText={searchText} setSearchText={setSearchText} handleSearch={handleSearch} handleClearSearch={handleClearSearch}/>

        <Box sx={{
          flex: 0.2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0,
          height: '100%'
        }}>

        </Box>

        <Box sx={{
          flex: 0.2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0,
          height: '100%'
        }}>

          <Button
            variant="contained"
            color="success"
            sx={{ borderRadius: 2, textTransform: "none", mr: 2, height: '100%', width: '200px' }}
            onClick={() => {
              onCreateClick();
            }}
          >
            Create Entertainment Entity
          </Button>

          <IconButton onClick={onToggleFilter} size='large'>
            <FilterListIcon />
          </IconButton>

        </Box>

      </Box>
    );
  }


  export default TopToolbar;